import { render, staticRenderFns } from "./CategoriesCreate.vue?vue&type=template&id=6a83de62&scoped=true"
import script from "./CategoriesCreate.vue?vue&type=script&lang=js"
export * from "./CategoriesCreate.vue?vue&type=script&lang=js"
import style0 from "./CategoriesCreate.vue?vue&type=style&index=0&id=6a83de62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a83de62",
  null
  
)

export default component.exports